<template>
    <div class="prescriptionTemplate" v-loading="loading">
        <div class="warp">
            <div class="warp-left">
                <div>
                    <el-input placeholder="请输入内容" prefix-icon="el-icon-search" @input="searchTemplate"
                        v-model="comboName" clearable>
                    </el-input>
                </div>
                <div class="list-warp">
                    <div class="top-nav" v-if="!comboName">医联产品</div>
                    <div class="numBox align-i-c just-c color6671 borderB_EBE" style="height: 32px;" v-if="comboName">
                        搜索到 <span class="ml4 mr4 color1F23">{{ comboList.length }}</span>
                        条信息
                    </div>
                    <div class="type-name">
                        <div class="type-warp" v-if="!comboName">
                            <div :class="activeDoctorId == item.doctorId ? 'active' : ''" v-for="item in doctorList"
                                :key="item.doctorId" @click="changeActiveDoc(item.doctorId)">{{
        item.doctorName }}
                                <img class="icon-img" :src="imgArr.file" />
                            </div>

                        </div>
                        <div class="name-warp pr" v-if="comboList.length == 0">
                            <el-empty :image-size="1" description="暂无处方信息">
                            </el-empty>

                        </div>
                        <div class="name-warp" v-if="comboList.length > 0"
                            :style="{ 'width': (comboName ? '440px' : '211px') }">
                            <div :class="activeComboId == item.comboId ? 'active' : ''" v-for="item in comboList"
                                :key="item.comboId" @click="changeActive(item.comboId)"
                                @dblclick.capture="userCombo(item.comboId)">{{
        item.comboName }}
                                <img class="icon-img" :src="imgArr.note" />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="btn-warp">
            <el-button @click="cancel">取消</el-button>
            <el-button @click="userModal" type="primary">使用</el-button>
        </div>
    </div>
</template>

<script>
import { Utils } from '@/utils/utils'
import { isNull, isEmptyArray } from "@/utils/validateBase";
import { imgArr } from "@/assets/images/img";
import { comboDTO } from '@/DTO/index'
export default {
    // 定义引入的组件
    components: {},
    props: {},
    data() {
        return {
            imgArr: imgArr,
            loading: false,
            comboName: '',
            doctorList: [],//医生列表
            activeDoctorId: '',//当前激活的医生id
            activeComboId: '',//当前激活的医联id
            comboList: [],//医联产品列表
            comboInfo: null,
        }
    },
    //变量监听
    watch: {},
    // 页面初始化
    async created() {
        await this.getDocList()
        if (isNull(this.activeDoctorId)) return
        await this.getComboList()
    },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        /**
        * 获取医生列表
        */
        async getDocList() {
            let { code, data } = await comboDTO.getComboDocDTO()
            if (code = 200) {
                this.doctorList = isNull(data) ? [] : data
                if (isNull(this.activeDoctorId)) {
                    this.activeDoctorId = isNull(data) ? '' : data[0].doctorId
                }
            }
        },
        /**
        * 获取医联产品列表
        */
        async getComboList() {
            let { code, data } = await comboDTO.getComboListDTO({ doctorId: this.activeDoctorId, comboName: this.comboName })
            if (code == 200) {
                this.comboList = isNull(data) ? [] : data
                this.comboList = _.sortBy(this.comboList, function (item) { return item.sort })
                if (isNull(this.activeComboId)) {
                    this.activeComboId = isEmptyArray(data) ? '' : data[0].comboId
                }
            }
        },
        /**
         * 获取医联详情
         */
        async getCombo() {
            if (isNull(this.activeComboId)) return;
            let { code, data } = await comboDTO.getComboDTO(this.activeComboId)
            if (code == 200) {
                this.comboInfo = isNull(data) ? null : data
            }
        },

        /**
         * 切换激活医生
         */
        changeActiveDoc(id) {
            this.activeDoctorId = id;
            this.activeComboId = null;
            this.getComboList();
        },
        /**
         * 切换激活医联产品
         */
        changeActive(id) {
            this.activeComboId = id;
        },
        /**
         * 取消
         */
        cancel() {
            this.$emit('cancel')
        },
        /**
         * 使用模版
         */
        async userModal() {
            await this.getCombo()
            this.$emit('comboInfoBack', this.comboInfo)
        },
        /**
         * 搜索处方模版
         */
        searchTemplate: _.debounce(function () {
            if (!isNull(this.comboName)) {
                this.activeDoctorId = null
                this.getComboList()
            } else {
                this.activeDoctorId = isEmptyArray(this.doctorList) ? '' : this.doctorList[0].doctorId
                this.getComboList()
            }
        }, 500),
        /**
         * 双击使用
         */
       async userCombo(id) {
        console.log(1111);
            this.activeComboId = id;
            await this.getCombo()
            this.$emit('comboInfoBack', this.comboInfo)
        }
    },
}
</script>
<style lang="less" scoped>
.prescriptionTemplate {
    height: 540px;
    display: flex;
    flex-direction: column;
    padding: 16px 20px;

    .warp {
        display: flex;
        height: 100%;
        overflow: auto;

        .warp-left {
            box-sizing: border-box;
            padding-right: 16px;
            width: 100%;
            height: 100%;
            // border-right: 1px solid #E1E1E1;
            display: flex;
            flex-direction: column;

            .list-warp {
                box-sizing: border-box;
                background: #FAFBFC;
                flex: 1;
                margin-top: 12px;
                display: flex;
                flex-direction: column;
                cursor: pointer;
                overflow: auto;
                border: 1px solid #D3D3D5;

                background: #F7F8F9;

                .top-nav {
                    box-sizing: border-box;
                    padding-top: 8px;
                    padding-left: 16px;
                    display: flex;
                    color: #666;
                    font-size: 14px;


                    &>div {
                        margin-right: 30px;
                        cursor: pointer;
                    }

                    .active {
                        color: #347EFF;
                        position: relative;

                        &::after {
                            position: absolute;
                            content: '';
                            display: block;
                            width: 48px;
                            bottom: -10px;
                            left: 50%;
                            border-bottom: 2px solid #347EFF;
                            transform: translateX(-50%);
                        }
                    }
                }

                .borderB_EBE {
                    border-bottom: 1px solid #EBEAEE;
                }

                .numBox {
                    display: flex;
                }


                .type-name {
                    box-sizing: border-box;
                    // margin-top: 10px;
                    display: flex;
                    color: #333;
                    font-size: 14px;
                    flex: 1;
                    overflow: auto;
                    margin-top: 10px;
                    border-top: 1px solid #D3D3D5;
                    width: 100%;

                    .active {
                        background: #E0EBFF;
                    }

                    .type-warp {

                        box-sizing: border-box;
                        height: 100%;
                        overflow-y: auto;
                        width: 211px;
                        border-right: 1px solid #D3D3D5;

                        & div {
                            margin-top: 10px;
                            padding: 6px;
                            position: relative;
                            padding-left: 38px;

                            .icon-img {
                                position: absolute;
                                top: 3px;
                                left: 12px;
                                width: 18px;
                                height: 18px;
                            }
                        }
                    }

                    .name-warp {
                        // width: 182px;
                        box-sizing: border-box;
                        height: 100%;
                        overflow-y: auto;

                        & div {
                            margin-top: 10px;
                            padding: 6px;
                            padding-left: 40px;
                            position: relative;

                            .icon-img {
                                position: absolute;
                                top: 3px;
                                left: 12px;
                                width: 18px;
                                height: 18px;
                            }
                        }
                    }
                }
            }
        }

        .warp-right {
            flex: 1;
            margin-left: 16px;
            overflow: auto;

            .right-title {
                color: #1F2329;
                font-size: 14px;
                font-weight: 500;
                text-align: left;
                background: #F0F1F3;
                padding: 8px 12px;
                border: 1px solid #D3D3D5;
                border-bottom: none;
            }

            .border-none {
                border-bottom: none !important;
            }

            .right-desc {
                // margin-top: 20px;
                border-left: 1px solid #D3D3D5;
                border-right: 1px solid #D3D3D5;
                border-top: 1px solid #D3D3D5;

                .desc-item {
                    display: flex;
                    line-height: 34px;
                    flex: 1;
                    border-bottom: 1px solid #D3D3D5;
                    background: #F7F8F9;

                    .item-label {
                        box-sizing: border-box;
                        padding-left: 14px;
                        width: 80px;
                        border-right: 1px solid #D3D3D5;
                        color: #667182;
                        font-size: 14px;
                    }

                    .item-value {
                        padding-left: 14px;
                    }
                }
            }

            .right-detail {
                margin-top: 20px;
                border: 1px solid #D3D3D5;


                .detail-title {
                    color: #1F2329;
                    font-size: 14px;
                    font-weight: 500;
                    text-align: left;
                    background: #F0F1F3;
                    padding: 8px 12px;
                    border-bottom: 1px solid #D3D3D5;

                }

                .drug-warp {
                    display: flex;
                    flex-wrap: wrap;
                    background: #F9F9FA;

                    .drug-item {
                        box-sizing: border-box;
                        height: 57px;
                        width: 25%;
                        padding: 10px;

                        border-right: 1px solid #D3D3D5;
                        border-bottom: 1px solid #D3D3D5;

                        .drug-name {
                            width: 94px;
                            color: #1F2329;
                            font-size: 14px;
                            font-weight: 500;
                            margin-bottom: 8px;
                        }
                    }
                }
            }
        }
    }

    .btn-warp {
        margin-top: 14px;
        text-align: right;
    }

}
</style>